export default __webpack_public_path__ + "static/media/config.7c8a13c3.svg";